module.exports = ".full-width {\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/consulta/diagnosticos/diagnosticosdetalle/diagnosticosdetalle.component.scss
// module id = ./src/app/consulta/diagnosticos/diagnosticosdetalle/diagnosticosdetalle.component.scss
// module chunks = main